import { defaults } from 'usage-tracker-core/common/helpers';
import hubtoolsTrackingClient from './client';
const DEFAULT_OPTS = {
  // As `events` is a required property from the TrackerConfig we define it here
  // but as a `undefined` value, so once the validation of TrackerConfig is done
  // it will throw an exception for not having the `events` property supplied.
  // as `undefined` will be interpreted as the value not being provided.
  events: undefined
};
export const createTracker = config => {
  const mergedOptions = defaults(config || DEFAULT_OPTS, DEFAULT_OPTS);
  return hubtoolsTrackingClient.createTracker(mergedOptions);
};